/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Comeback_DietInputs */

const en_portal_goal_comeback_diet = /** @type {(inputs: Portal_Goal_Comeback_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein for recovery`)
};

const pl_portal_goal_comeback_diet = /** @type {(inputs: Portal_Goal_Comeback_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Białko pod regenerację`)
};

/**
* | output |
* | --- |
* | "Protein for recovery" |
*
* @param {Portal_Goal_Comeback_DietInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_comeback_diet = /** @type {((inputs?: Portal_Goal_Comeback_DietInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Comeback_DietInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_comeback_diet(inputs)
	return en_portal_goal_comeback_diet(inputs)
});